import type { GalleryDesignTokens } from '@primeuix/themes/types/gallery';

export default {
    backdrop: {
        background: '{surface.950}',
    },
    header: {
        padding: '0.75rem 1rem',
        background: '{surface.950}',
    },
    footer: {
        padding: '0.25rem 0',
        background: '{surface.950}',
        borderColor: '{surface.800}',
    },
    item: {
        transitionDuration: '0.3s',
    },
    action: {
        size: '2.25rem',
        borderRadius: '50%',
        color: '{surface.400}',
        hoverBackground: '{surface.800}',
        hoverColor: '{surface.0}',
        disabledOpacity: '{disabled.opacity}',
        transitionDuration: '{transition.duration}',
        icon: {
            size: '1rem',
        },
    },
    navigation: {
        background: 'color-mix(in srgb, {surface.800}, transparent 40%)',
        size: '2.25rem',
        borderRadius: '50%',
        color: '{surface.400}',
        hoverBackground: '{surface.800}',
        hoverColor: '{surface.0}',
        offset: '0.5rem',
        transitionDuration: '{transition.duration}',
        icon: {
            size: '1rem',
        },
    },
    thumbnail: {
        size: '5rem',
        padding: '0.25rem',
        background: '{surface.800}',
        borderRadius: '0.25rem',
        borderWidth: '3px',
        hoverBorderColor: '{surface.700}',
        activeBorderColor: '{primary.color}',
        activeScale: '0.85',
        transitionDuration: '{transition.duration}',
    },
    thumbnailContent: {
        padding: '0.25rem 0',
    },
} satisfies GalleryDesignTokens;
